import {createEntityService} from 'utils/createEntityService';
import {DocumentTemplateElement} from '../types/documentTemplateElement';

export const DocumentTemplateElementService =
  createEntityService<DocumentTemplateElement>({
    baseUrl: 'api/v1/document_template_elements',
    entityName: 'documentTemplateElement',
  });
